import ListViewCpt from '@/components/list/ListViewCpt';
import { rqtPostListCustomerQueryPage } from '@/services/cms/customer';
const searchTypeRes = ['客户姓名', '客户号', '身份证号'];
export default {
  name: 'CustomerQuery2Cpt',
  components: {
    ListViewCpt
  },
  data() {
    return {
      show: false,
      searchValue: '',
      searchForm: {
        chnName: undefined,
        customerNo: undefined,
        idNo: undefined
      },
      searchTypeRes,
      searchType: searchTypeRes[0],
      listRequest: rqtPostListCustomerQueryPage
    };
  },
  methods: {
    showView() {
      this.show = true;
    },
    onSearchTypeClick(value, isClick = true) {
      const index = searchTypeRes.findIndex(e => e == value);
      switch (index) {
        case 0:
          this.searchForm.chnName = this.searchValue;
          this.searchForm.customerNo = undefined;
          this.searchForm.idNo = undefined;
          if (isClick) {
            this.searchType = searchTypeRes[1];
          }
          break;
        case 1:
          this.searchForm.chnName = undefined;
          this.searchForm.customerNo = this.searchValue;
          this.searchForm.idNo = undefined;
          if (isClick) {
            this.searchType = searchTypeRes[2];
          }
          break;
        case 2:
          this.searchForm.chnName = undefined;
          this.searchForm.customerNo = undefined;
          this.searchForm.idNo = this.searchValue;
          if (isClick) {
            this.searchType = searchTypeRes[0];
          }
          break;
      }
    },
    onSearch() {
      this.onSearchTypeClick(this.searchType, false);
      this.$refs['ListViewCpt'].initListData();
    },
    onListItemClick(item) {
      this.$emit('selected', item);
      this.show = false;
    }
  }
};